import React, { useState } from 'react';

function About() {
  const [showMore, setShowMore] = useState(false);

  return (
    <>
      <section id="about" className="about section">
        {/* Section Heading */}
        <div className="container section-title" data-aos="fade-up">
          <h2>Chairman’s Message</h2>
          <p>A Message of Leadership, Trust, and Commitment</p>
        </div>

        <div className="container">
          <div className="row gy-4 align-items-center">

            {/* Chairman Image */}
            <div
              className="col-lg-6 order-1 order-lg-2 text-center"
              data-aos="fade-up"
              data-aos-delay="100"
            >
              <img
                src="/assets/img/ceo.jpg"
                className="img-fluid chairman-img"
                alt="Chairman"
              />
               {/* Name and Designation */}
  <h3 className="mt-3">Mansoor Khan AC</h3>
  <p>Chairman, AL MAC Tradings & Service Company</p>
            </div>

            {/* Content */}
            <div
              className="col-lg-6 order-2 order-lg-1 content chairman-content"
              data-aos="fade-up"
              data-aos-delay="200"
            >
              <h3>Leading With Vision Since 2003</h3>

              <p className="fst-italic highlight-text">
                “Leading with quality, innovation, and integrity”
              </p>

              <p>
                From the beginning, our goal has been to build a group of companies
                that stand for quality, honesty, and meaningful service. Over the
                years, we have expanded into food services, building materials,
                plastic and cosmetics, catering, and logistics—each shaped by the
                same commitment to excellence.
              </p>

              <p>
                Our strength comes from our people, who work every day with
                dedication and discipline to serve customers across Makkah and
                beyond. True success, for us, lies in delivering value to society
                while creating sustainable growth opportunities.
              </p>

              <p>
                As we move forward, we remain committed to professionalism,
                innovation, and customer satisfaction. Thank you for your trust
                and continued support.
              </p>
            </div>

          </div>
        </div>
      </section>

      {/* ✅ CSS INSIDE SAME FILE */}
      <style jsx>{`
        /* Chairman Image */
        .chairman-img {
          max-width: 85%;
          border-radius: 12px;
          margin-left: 40px;
        }

        /* Content spacing */
        .chairman-content {
          padding-right: 40px;
        }

        /* Improve text readability */
        .chairman-content p {
          font-size: 1.05rem;
          line-height: 1.8;
          color: #555;
        }

        /* Sub heading */
        .chairman-content h3 {
          font-size: 1.6rem;
          margin-bottom: 12px;
          color: #222;
        }

        /* Highlight quote */
        .highlight-text {
          font-size: 1.1rem;
          color: #666;
          margin-bottom: 18px;
        }

        /* Section title */
        .section-title h2 {
          font-size: 2.2rem;
          font-weight: 700;
        }

        .section-title p {
          font-size: 1rem;
          color: #777;
        }

        /* Mobile adjustments */
        @media (max-width: 991px) {
          .chairman-img {
            margin-left: 0;
            max-width: 90%;
          }

          .chairman-content {
            padding-right: 0;
            margin-top: 20px;
          }
        }
      `}</style>
    </>
  );
}

export default About;
